

import React, { Component } from 'react'; 
  
import { createBrowserHistory } from 'history';
import { Chart } from 'react-chartjs-2';
import { ThemeProvider } from '@material-ui/styles';
import validate from 'validate.js';

import { chartjs } from './helpers';
import theme from './theme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.css';
import validators from './common/validators';
//

import './App.css';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Login from "./Routes/Login";
import Admin from "./Routes/admin";
import Player from "./Routes/Player";
import Painel from "./Routes/painel";
const browserHistory = createBrowserHistory();
 
Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
    draw: chartjs.draw
});

validate.validators = {
    ...validate.validators,
    ...validators
};

export default class App extends Component {
    render() {
        return (
            <ThemeProvider theme={theme}>
                <Router history={browserHistory}>
                    <Router>
                        <Route exact path={"/"} component={Login} />
                        <Route path={"/player/:id"} component={Player} />
                        <Route path={"/admin"} component={Admin} />
                        <Route path={"/painel"} component={Painel} />
                    </Router>
                </Router>
            </ThemeProvider>
        );
    }
}
